import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const cellRichTextClasses = `
  max-w-none
  [&_p]:my-0
  [&_ul]:my-0
  [&_ul]:pl-6
  [&_li]:my-2
  [&_a]:text-[#1371DC]
  [&_a]:no-underline
  [&_a:hover]:underline
`;

const countryRichTextClasses = `
  max-w-none
  [&_p]:my-0
`;

const SimpleTableRow = ({ blok }) => {
  return (
    <tr {...storyblokEditable(blok)} className="bg-[#F3F3F3]">
      <td className="border border-[#666] px-6 py-10 text-center align-middle text-[20px] md:text-[24px] font-medium text-black whitespace-nowrap">
        <div className={countryRichTextClasses}>
          {customRenderRichText(blok.country)}
        </div>
      </td>

      <td className="border border-[#666] px-8 py-10 align-top text-[16px] md:text-[18px] text-black">
        <div className={cellRichTextClasses}>
          {customRenderRichText(blok.col_2_content)}
        </div>
      </td>

      <td className="border border-[#666] px-8 py-10 align-top text-[16px] md:text-[18px] text-black">
        <div className={cellRichTextClasses}>
          {customRenderRichText(blok.col_3_content)}
        </div>
      </td>

      <td className="border border-[#666] px-8 py-10 align-top text-[16px] md:text-[18px] text-black">
        <div className={cellRichTextClasses}>
          {customRenderRichText(blok.col_4_content)}
        </div>
      </td>
    </tr>
  );
};

export default SimpleTableRow;